export const preloadLivePagesComponents = async () => {
	return (
		await import(
			/* webpackChunkName: "loadable-livePages-preloader" */
			'./livePages-preloader.js'
		)
	).preloadLivePagesComponents();
};

export const preloadViewPageComponents = async (...args) => {
	return (
		await import(
			/* webpackChunkName: "loadable-viewPage-preloader" */
			'./view-page.js'
		)
	).preloadViewPage(...args);
};

export const preloadSpaceOverview = async () => {
	(
		await import(/* webpackChunkName: "loadable-preloadersspace-overview" */ './space-overview.js')
	).preloadSpaceOverview();
};

export const preloadSearch = async () => {
	(await import(/* webpackChunkName: "loadable-preloaderssearch" */ './search.js')).preloadSearch();
};

export const preloadHome = async (...args) => {
	(await import(/* webpackChunkName: "loadable-preloadershome" */ './home.js')).preloadHome(
		...args,
	);
};

export const preloadNativeEditorComponentsPreloader = async () => {
	(
		await import(
			/* webpackChunkName: "loadable-nativeEditorComponentsPreloader" */ '@confluence-classic/confluence-fabric-editor/src/lib/index.ts'
		)
	).nativeEditorComponentsPreloader();
};

export const preloadCreateContent = async () => {
	(
		await import(/* webpackChunkName: "loadable-preloaderscreate-content" */ './create-content.js')
	).preloadCreateContentRoute();
};

export const preloadWhiteboardPage = async () => {
	(
		await import(
			/* webpackChunkName: "loadable-preloaderswhiteboard-page" */ './whiteboard-page.js'
		)
	).preloadWhiteboardPage();
};
